import React from "react";
import { useLang } from "../context";
import { FAQ as FAQ_DATA } from "../content";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function FAQ() {
  const { lang } = useLang();
  const items = FAQ_DATA[lang];
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 pt-12 pb-10">
      <p className="text-xs uppercase tracking-[0.3em] text-[#737373] mb-5">{lang === "fr" ? "Aide & informations" : "Help & information"}</p>
      <h1 className="serif text-5xl lg:text-6xl mb-12">FAQ</h1>
      <Accordion type="single" collapsible>
        {items.map((it, i) => (
          <AccordionItem key={it.q} value={`item-${i}`} className="border-b border-[#1A1A1A]/15">
            <AccordionTrigger data-testid={`faq-${i}`} className="serif text-xl text-left">{it.q}</AccordionTrigger>
            <AccordionContent className="text-base text-[#404040] leading-relaxed">{it.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
